module.exports = __webpack_public_path__ + "static/media/traffic-light.03a7b189.svg";